import { Injectable } from "@angular/core";
import { ApiService } from "../api.service";

const PATH = "util";

@Injectable({
  providedIn: "root",
})
export class UtilHandlerService {
  constructor(private apiService: ApiService) {}

  tagsGet(masterAccountID: number) {
    return this.apiService.get(`${PATH}/tags/${masterAccountID}`);
  }
}
